<template>
  <base-section id="gallery">
    <base-section-heading title="Our Library">
      View some of the artists we have in our asset collection below
    </base-section-heading>
    <v-tabs
      v-model="tab"
      centered
      class="mb-12"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.name"
        :href="`#${tab.toLowerCase()}`"
        class="text-capitalize"
      >
        {{ tab }}
      </v-tab>
    </v-tabs>
    <v-container>
      <v-fade-transition
        group
        hide-on-leave
        tag="v-row"
      >
        <v-col
          v-for="(project) in projects"
          :key="project.title"
          class="gallery-card"
          cols="12"
          sm="6"
          md="4"
        >
          <project-card
            v-bind="project"
            :src="require(`@/assets/`+project.img)"
            height="300"
            width="100%"
          />
        </v-col>
      </v-fade-transition>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionGallery',

    components: {
      ProjectCard: () => import('@/components/ProjectCard'),
    },

    data: () => ({
      tab: 'All',
      tabs: [
        'All',
        'Hip-Hop',
        'Rock',
        'DJ',
        'Live Performance',
        'Other',
      ],
    }),

    computed: {
      projects () {
        return [
          { title: 'Bone Thugs-N-Harmony', subtitle: 'Hip-Hop', img: 'project-1.jpg' },
          { title: 'Radioactive Chicken Heads', subtitle: 'Rock', img: 'project-2.jpg' },
          // { title: 'Ouija Macc', subtitle: 'Hip-Hop', img: 'project-3.jpg' },
          { title: 'Rocky Rock', subtitle: 'Hip-Hop', img: 'project-4.jpg' },
          { title: 'Angelo Moore (Fishbone)', subtitle: 'Rock', img: 'project-5.jpg' },
          { title: 'MoniKa Starling', subtitle: 'DJ', img: 'project-6.jpg' },
          { title: 'Organized Noize', subtitle: 'Hip-Hop', img: 'project-7.png' },
          { title: 'Sleepy Brown', subtitle: 'Hip-Hop', img: 'sleepy.jpg' },
          // { title: 'Gemini Syndrome', subtitle: 'Rock', img: 'project-9.jpg' },
          // { title: 'Authority Zero', subtitle: 'Rock', img: 'project-10.jpg' },
          // { title: 'Bradyn Kramer', subtitle: 'Live Performance' },
          // { title: 'Bailey Wolfe', subtitle: 'Live Performance' },
          // { title: 'Lorelei Holloway', subtitle: 'Hip-Hop' },
          // { title: 'Justine Elliott', subtitle: 'Other' },
        ].filter(project => {
          if (this.tab.toLowerCase() === 'all') return true

          return project.subtitle.toLowerCase() === this.tab.toLowerCase()
        })
      },
    },
  }
</script>

<style lang="sass">
  .gallery-card
    transform-origin: center center 0
    transition: .3s cubic-bezier(.25,.8,.50,1)
</style>
